export default __webpack_public_path__ + "static/bootstrap-react-negative-8906ab54dbed7e96eef6126d5e898ed6.svg";